<template>
  <div id="sshet-basic-details">
    <mai-modal v-if="modal" @close="modal = false" :title="this.cloneTitle">
      <copy-descriptor
        slot="content"
        :main-id="this.main"
        :parent-id="this.parent"
        :type="this.type"
        @close="modal = false"
        @enableSave="toggleCloneSave"
        ref="cloneSpreadsheet" />
      <div slot="footer">
        <div :class="cloneSaveCss" @click="$refs.cloneSpreadsheet.go()">
          Save
        </div>
        <div class="btn btn-danger sq" @click="modal = false">
          Close
        </div>
      </div>
    </mai-modal>
    <div class="row">
      <div class="col-xs-12">
        <div class="shadow clearfix">
          <div v-show="viewing === 'all'">
            <div class="col-xs-12">
              <div class="text-right">
                <div class="btn btn-success sq" @click="add">Add</div>
                <div v-show="this.displayCloneButton" class="btn btn-primary sq" @click="popup">Copy From</div>
              </div>
              <vue-table
                :tableData="details"
                :tableTitle="tableTitle"
                v-on:table-edit-request="updateActive"
                :showEdit="true"
                v-on:table-delete-request="doDelete"
                :showDelete="true"
                :fields="fields"
              ></vue-table>
              <div class="text-right">
                <div class="btn btn-success sq" @click="add">Add</div>
                <div v-show="this.displayCloneButton" class="btn btn-primary sq" @click="popup">Copy From</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import HelperMixin from '../../mixins/Helpers'
  import VueTable from '../../../helpers/VueTable'
  import API from '../../../../api/endpoints'
  import event from '../../../../event'
  import { createRouteIdHash } from '../../../helpers/RouteHash'
  import SheetMixin from './SheetMixin'
  import MaiModal from '../../../../components/MaiModal.vue'
  import CopyDescriptor from './SpreadsheetDescriptorCopy'
  export default {
    name: 'SpreadSheetTariffDetails',
    mixins: [ HelperMixin, SheetMixin ],
    components: {
      VueTable, MaiModal, CopyDescriptor
    },
    props: [ 'dets', 'parent', 'getForParent', 'visible', 'type', 'main' ],
    data () {
      return {
        fields: [
          { header: 'Name', prop: item => item.tariff ? this.getTariff(item.tariff) + ` ${item.name}` : item.name },
          { header: 'Tab', prop: 'tabName' }
        ],
        details: [],
        viewing: 'all',
        descriptorToView: null,
        entity: {
          id: null,
          dataType: null,
          property: null,
          tabName: null,
          cell: null,
          startRow: null,
          endRow: null,
          startColumn: null,
          endColumn: null,
          entityType: this.sheetDescLookupHeader,
          parent: null
        },
        updateClicked: false,
        modal: false,
        enableClone: false
      }
    },
    watch: {
      details: {
        deep: true,
        handler: function (newVal, oldVal) {
          // this.$emit('updating', newVal)
        }
      },
      dets: {
        deep: true,
        handler: function (newVal, oldVal) {
          if (JSON.stringify(newVal) !== JSON.stringify(this.details)) {
            this.details = newVal
          }
        }
      }
    },
    computed: {
      routeType () {
        return this.type || 'Tariff'
      },
      saveOrUpdate () {
        return this.entity.id !== null ? 'Update' : 'Save'
      },
      saveMethod () {
        return this.entity.id !== null ? 'put' : 'post'
      },
      saveUrl () {
        return this.entity.id ? API.UPDATE_ADMIN_ENTITY('spreadsheet-descriptor', this.entity.id) : API.CREATE_ADMIN_ENTITY('spreadsheet-descriptor')
      },
      cloneTitle () {
        return 'Copy ' + this.type
      },
      displayCloneButton () {
        return this.type === 'Note' || this.type === 'Static'
      },
      cloneSaveCss () {
        return this.enableClone ? 'btn btn-primary sq' : 'disabled btn btn-primary sq'
      },
      tableTitle () {
        if (this.type === 'Static') {
          return 'Static Costs '
        } else if (this.type === 'Note') {
          return 'Notes'
        } else {
          return 'Tariffs'
        }
      }
    },
    methods: {
      add () {
        this.$router.push({ name: 'Admin - Add Spreadsheet ' + this.routeType + ' Descriptor', params: { id: createRouteIdHash(this.parent) } })
      },
      getTariff (id) {
        let tar = id ? this.getSystemOption(id) : null
        return tar ? tar.name : ''
      },
      updateActive ({ item, index }) {
        this.$router.push({ name: 'Admin - Edit/View Spreadsheet ' + this.routeType + ' Descriptor', params: { id: createRouteIdHash(item.id) } })
      },
      getDataType (id) {
        if (id !== null) {
          let o = this.getSystemOption(id)
          return o && o.hasOwnProperty('name') ? o.name : ''
        }
        return ''
      },
      save () {
        if (!this.updateClicked) {
          this.updateClicked = true
          this.$http[this.saveMethod](this.saveUrl, { ...this.entity, entityType: this.sheetDescLookupHeader, parent: this.parent })
          .then(({data}) => {
            if (data.hasOwnProperty('id')) {
              this.entity.id = data.id
              this.addToList({ ...this.entity })
              event.$emit('toast', { type: 'success', message: 'Saved successfully' })
            }
          }).catch(err => {
            event.$emit('toast', { type: 'error', message: err.message })
            console.log(err)
          }).then(() => {
            this.updateClicked = false
          })
        }
      },
      addToList (de) {
        let i = this.details.findIndex(d => d.id === de.id)
        if (i === -1) {
          this.details.push(de)
        } else {
          for (let prop in de) {
            this.details[i][prop] = de[prop]
          }
        }
        this.doClear()
      },
      doClear () {},
      doDelete ({ item, index }) {
        this.$http.delete(API.DELETE_ADMIN_ENTITY('spreadsheet-descriptor', item.id))
        .then(res => {
          let i = this.details.findIndex(({id}) => id === item.id)
          if (i > -1) {
            this.details.splice(i, 1)
          }
          event.$emit('toast', { type: 'success', message: 'Item Deleted' })
          this.doClear()
        }).catch(err => {
          event.$emit('toast', { type: 'error', message: err.message })
          console.log(err)
        })
      },
      getBaseData () {
        return {
          id: null,
          dataType: null,
          property: null,
          tabName: null,
          cell: null,
          startRow: null,
          endRow: null,
          startColumn: null,
          endColumn: null,
          entityType: this.sheetDescLookupHeader
        }
      },
      popup () {
        this.modal = true
      },
      toggleCloneSave (value) {
        this.enableClone = value
      }
    }
  }
</script>
<style></style>



// WEBPACK FOOTER //
// src/modules/admin/components/SpreadsheetDescriptor/TariffDetails.vue